import { useRouter } from 'next/router';
import { useTeamsData } from '@lib/hooks/useTeamsData';
import { useStreamData } from '@lib/hooks/useStreamData';
import Button from '@atoms/Button';

import DropdownDestination from '@molecules/DropDownDestination';
import Logo from '@atoms/Logo';
import Container from '@atoms/Container';
import UserGuide from '@components/UserGuide';

const Header = (props) => {
  const router = useRouter();
  const { showUserGuide, setShowUserGuide } = useStreamData(s => ({ showUserGuide: s.showUserGuide, setShowUserGuide: s.setShowUserGuide }));
  const ownTeam = useTeamsData((s) => s.ownTeam);
  const doLogout = useTeamsData((s) => s.doLogout);

  const logout = async() => {
    await doLogout();
    router.push('/login');
  };

  const showBanner = () => (
    ['home', 'landing'].includes(props?.page)
    && ownTeam?.billing_account?.purchase_plan?.name === 'Free Plan'
  );

  return (
    <div className={`sticky top-0 w-full bg-white z-40 ${!props.shape && ''}`}>
      {showUserGuide && <UserGuide onCancel={() => setShowUserGuide(false)} />}
      <Container type='type0' className={'py-2 mx-auto'}>
        <div className="flex items-center justify-between top-header">
          {
            !props.logoClick && <Logo id="saLogoId" src="/images/logos/logo_tag_black.svg" className="max-w-[156px] block" />
          }

          {
            props.logoClick && <Logo id="saLogoId" src="/images/logos/logo_tag_black.svg" className="max-w-[156px] block" />
          }

          <div className="flex items-center justify-end w-full">

            {props.isLoggedIn && !props.noLgBtn && props.nav
              && <>
                <DropdownDestination logout={logout} page={props.page} />
              </>
            }

            {
              props.logout
              && <Button className="mr-2 font-semibold lg:text-base lg:leading-5 rounded-lg"
                type="ghost" onClick={logout}>Logout</Button>
            }

          </div>
        </div>
      </Container >

      {showBanner()
        ? <div className='bg-neutral-10'>
          <div className="bg-semantic-successLight-50 flex justify-center w-full p-2 text-sm leading-6">
            You’re on a Free Plan. For branding, more participants, etc.
            <a
              className='text-primary-500 cursor-pointer font-semibold'
              onClick={() => router.push('/pricing')}
            >
              &nbsp;Upgrade Now
            </a>
          </div>
        </div>
        : null
      }
    </div >
  );
};
export default Header;
